<template>

    <div>
        <vs-row vs-w="12">
            <vs-col vs-w="5" vs-sm="12" class="p-2">
                <vx-card :title='$t("BasicSettings")' collapse-action>

                    <p class="mt-6">{{$t("Name")}}</p>
                    <vs-input v-model="settings['name']" style="width: 100%"/>

                    <p class="mt-6">{{$t("MinimalWorkTimePerDay")}}</p>
                    <vs-input type="number" v-model="settings['minimum_time_daily']" style="width: 100%"/>

                    <vs-checkbox class="mt-6" v-model="settings['ignore_multipliers']" >{{$t("IgnoreMultipliers")}}</vs-checkbox>

                    <vs-checkbox class="mt-6" v-model="settings['carry_time_over']" >{{$t("CarryTimeOver")}}</vs-checkbox>

                    <vs-button color="success" type="border" class="mt-6" @click="editUserType">{{$t("Save")}}</vs-button>
                    <vs-button color="danger" style="float:right;;" type="border" class="mt-6" @click="removeUserType">{{$t("Remove")}}</vs-button>


                </vx-card>
            </vs-col>
            <vs-col vs-w="7" vs-sm="12" class="p-2">
                <month-times-table :typeId="Number(this.$route.params.id)" />
            </vs-col>
            <vs-col vs-w="6" vs-sm="12" class="p-2">
                <user-type-notifications-table :typeId="Number(this.$route.params.id)" />
            </vs-col>
        </vs-row>
    </div>

</template>
<script>

    import MonthTimesTable from "./MonthTimesTable";
    import UserTypeNotificationsTable from "./UserTypeNotificationsTable";

    export default {
        components: {
            UserTypeNotificationsTable,
            MonthTimesTable
        },
        data() {
            return {
                settings: {},
            }
        },
        methods: {
            updateUserType() {

                const thisIns = this;
                this.$http.get('/api/v1/user_type/' + this.$route.params.id)
                    .then(function (response) {

                        thisIns.settings = response.data;

                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            editUserType() {

                const thisIns = this;
                this.settings['minimum_time_daily'] = Number(this.settings['minimum_time_daily']);
                this.$http.put('/api/v1/user_type/' + this.$route.params.id, this.settings)
                    .then(function () {
                        thisIns.updateUserType();
                        thisIns.$vs.notify({
                            title:'Success',
                            position:'top-right',
                            text: thisIns.$t("Saved"),
                            color:'success',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            removeUserType() {
                const thisIns = this;
                this.$http.delete('/api/v1/user_type/' + this.$route.params.id)
                    .then(function () {
                        thisIns.updateUserType();
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        created() {
            this.updateUserType();
        }
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
